import FeaturedCourseSlider from '@/components/sliders/FeaturedCourseSlider'
import * as React from 'react'
declare const I18n;

type Course = {
  id: number
  title: string
  required_level: number
  active: boolean
  completed?: boolean
  lessons_completed?: number
  lessons_submitted?: number
  completed_lessons?: number
  total_lessons?: number
  progress?: number
  cover_image_data?: any
  description?: string
  type?: string
  is_deleted?: boolean
  language?: string
  created_at?: string
  updated_at?: string
}

type Props = {
  courses: Course[]
  userLevel?: number
  userType?: string
}

export const DashboardContainer: React.FC<Props> = ({
  courses,
  userType,
  userLevel,
}) => {
  const isLearner = !!(userType && userType === 'Learner');
  const isFacilitator = !!(userType && userType === 'Facilitator');

  const activeCourses = (courses || []).filter(course => course.active === true);

  // Determine in-progress: at least 1 lesson completed or submitted (or any progress indicator available)
  const isInProgress = (course: Course): boolean => {
    // Check if course is fully completed
    if (course.completed === true) return true;

    // Check lessons_completed or lessons_submitted
    const completedCount = (course.lessons_completed ?? course.completed_lessons ?? 0) as number;
    const submittedCount = (course.lessons_submitted ?? 0) as number;

    if (completedCount > 0) return true;
    if (submittedCount > 0) return true;

    // Check progress percentage
    if (typeof course.progress === 'number' && course.progress > 0) return true;

    return false;
  };

  // Filter to in-progress courses for both learners and facilitators
  const filteredCourses = (isLearner || isFacilitator) ? activeCourses.filter(isInProgress) : activeCourses;

  return (
    <div className="dashboard-container filled">
      <FeaturedCourseSlider
        courses={[...new Map((filteredCourses || []).map(c => [c.id, c])).values()]}
        isFacilitator={!!(userType && userType === 'Facilitator')}
        isLearner={isLearner}
        learnerLevel={userLevel || 0}
        heading={(isLearner || isFacilitator)
          ? I18n.t("models.course.messaging.in_progress")
          : I18n.t("models.course.messaging.recommended_course")} 
        viewAllText={I18n.t("models.course.messaging.view_all_courses")}
        viewAllUrl="/courses"
        emptyStateText={(isLearner || isFacilitator) ? I18n.t("models.course.messaging.no_course_in_progress") : I18n.t("models.course.messaging.no_course_available")}
        showProgress
        showBookIcon={true}
      />

      {/* Resources for You */}

    </div>
  )
}

export default DashboardContainer